import { KeySpaceInformation } from '../model/keySpaceInformation';
import { AdminPrecedingSpacesBuilder } from './adminPrecedingSpaces-builder';
import * as _ from 'lodash-es';
export class AdminKeySpaceInformationBuilder {
    static buildAdminKeySpaceInformation(data) {
        const adminKeySpaceInformation = new KeySpaceInformation();
        adminKeySpaceInformation.id_key_space = data.id_key_space;
        adminKeySpaceInformation.block = data.block;
        adminKeySpaceInformation.col = data.col;
        adminKeySpaceInformation.row = data.row;
        adminKeySpaceInformation.id_key_zone = data.id_key_zone;
        adminKeySpaceInformation.key_zone_name = data.key_zone_name;
        adminKeySpaceInformation.is_buffer = data.is_buffer;
        adminKeySpaceInformation.preceding_vehicles = data.preceding_vehicles;
        adminKeySpaceInformation.preceding_spaces = _.map(data.preceding_spaces, (precedingSpaces) => {
            return AdminPrecedingSpacesBuilder.buildPrecedingSpaces(precedingSpaces);
        });
        return adminKeySpaceInformation;
    }
}
//# sourceMappingURL=adminKeySpaceInformation-builder.js.map